import React from "react";
import ProcedureMoveAppBar from "./ProcedureMoveAppBar";
import DeletePageHeader from "./DeletePageHeader";
import DeleteLoadingScreen from "./DeleteLoadingScreen";
import DeleteModal from "./DeleteModal";
import Snackbar from "./Snackbar";

const DeletePageLayout = ({
  // Props for app bar
  selectedView,
  setSelectedView,
  onConfirm,
  
  // Props for header
  type,
  partNumber,
  status,
  revision,
  isProcedureSelected,
  
  // Props for loading
  isLoading,
  itemName,
  
  // Props for modals
  isModalOpen,
  isConfirmModalOpen,
  setModalOpen,
  setConfirmModalOpen,
  comment,
  setComment,
  onConfirmSave,
  
  // Props for snackbar
  snackbar,
  onCloseSnackbar,
  
  // Props for content
  children,
}) => {
  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      <DeleteLoadingScreen isLoading={isLoading} itemName={itemName} />

      <ProcedureMoveAppBar
        showBackButton={false}
        showCancelButton={true}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
        title="Please Confirm the Changes"
        buttons={[{ label: "Confirm", onClick: onConfirm }]}
      />
      
      <DeletePageHeader
        type={type}
        partNumber={partNumber}
        status={status}
        revision={revision}
        isProcedureSelected={isProcedureSelected}
      />
      
      {children}
      
      {/* Snackbar */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={onCloseSnackbar}
        />
      )}

      {/* Confirmation Modal */}
      <DeleteModal
        isOpen={isConfirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        title="Delete Confirmation"
        itemName={itemName}
        partNumber={partNumber}
        type={type}
        revision={revision}
        isLoading={isLoading}
        onConfirm={() => {
          setModalOpen(true);
          setConfirmModalOpen(false);
        }}
        isConfirmModal={true}
      />

      {/* Comment Modal */}
      <DeleteModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title="Delete Confirmation"
        itemName={itemName}
        partNumber={partNumber}
        type={type}
        revision={revision}
        isLoading={isLoading}
        onConfirm={onConfirmSave}
        comment={comment}
        setComment={setComment}
        isConfirmModal={false}
      />
    </div>
  );
};

export default DeletePageLayout;
